// import React, { useEffect, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import { FormParser } from '../FormParser/FormParser';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig"
// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([])
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [ADDRESSType, setAddressType] = useState("Home");
//     const [City, setcity] = useState("");
//     const [error, setError] = useState(false);
//     const [state, setState] = useState("");
//     let storedPincode = localStorage.getItem("pincode") ? (localStorage.getItem("pincode")) : "";
//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: storedPincode,
//         mobileno: "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });
//     // Handle change event
//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, ["landmark"]: selectedOption.label })
//     };
//     const handleInput = (e) => {
//         const { name, value } = e.target
//         setFormData({ ...formData, [name]: value })
//     }
//     console.log(formData)
//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (formData.id) {
//                 const res = await axiosConfig.patch(`/accounts/address/${formData.id}/`, { ...formData, "user": localStorage.getItem("userId") });
//                 console.log(res, "address added")
//                 setPopupType("success")
//                 handleCloseModal();
//                 setcity("")
//                 setState("")
//                 GetData && GetData();
//             }
//             else {
//                 const res = await axiosConfig.post(`/accounts/address/`, { ...formData, "user": localStorage.getItem("userId") });
//                 console.log(res, "address added")
//                 setPopupType("success")
//                 handleCloseModal();
//                 setcity("")
//                 setState("")
//                 GetData && GetData();
//             }
//         }
//         catch (error) {
//             console.error(error);
//             setPopupType("error")
//         }
//     }
//     const localityFilter = async () => {
//         if (formData.pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?city=&is_suspended=false&pincode=${formData.pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results)
//                     setcity(res.data.results[0]?.city?.city_name)
//                     setState(res.data.results[0]?.city?.state?.state_name)
//                     setError(false)
//                 }
//                 else {
//                     setError(true)
//                     setcity("")
//                     setState("")
//                     setOptions([])
//                 }
//             }
//             catch (error) {
//                 console.error(error);
//                 setError(true)
//             }
//         }
//         else {
//             return null
//         }
//     }
//     const handleCloseModal = () => {
//         closeAddressModal()
//         setError("")
//         setState("")
//         setcity("")
//         setData&&setData()
//         const storedPincode = localStorage.getItem("pincode") ? (localStorage.getItem("pincode")) : "";
//         setFormData({
//             name: "",
//             pincode: storedPincode,
//             mobileno: "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         })
//     }
//     useEffect(() => {
//         if (Data) {
//             console.log("Data")
//             setFormData(Data);
//         } else {
//             const storedPincode = localStorage.getItem("pincode") || "";
//             const number = localStorage.getItem("number") || "";
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 pincode: storedPincode,
//                 mobileno:number
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         localityFilter();
//     }, [formData.pincode,addressModal]);

//     return (
//         <Modal
//             size="lg"
//             show={addressModal}
//             onHide={handleCloseModal}
//             aria-labelledby="example-modal-sizes-title-lg"
//             centered
//         >
//             <Modal.Header closeButton>
//                 <Modal.Title id="example-modal-sizes-title-lg">
//                     {Data?.id ? "Edit Address" : "Add Address"}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {
//                     JSON.parse(localStorage.getItem("site_data"))?.ecommerce_type === "Conventional" ? <form onSubmit={formConventionalSubmit}>
//                         <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
//                         <div className='form-group'>
//                             <label>Name*:</label>
//                             <input className='form-control' placeholder='Name' name='name' value={formData.name} onChange={handleInput} required />
//                         </div>
//                         <div className='form-group'>
//                             <label>Mobile No*:</label>
//                             <input className='form-control' placeholder='Mobile No' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                         </div>
//                         <div className='addressFormUI-base-formHeader'>ADDRESS</div>
//                         <div className='form-group'>
//                             <label>Pincode*:</label>
//                             <input className='form-control' type='number' placeholder='Pincode' maxLength="6" name='pincode' value={formData.pincode} onChange={handleInput} required />
//                             {error &&
//                                 <div className="Loginerror">Service not available for this selected pincode</div>
//                             }
//                         </div>
//                         <div className='form-group'>
//                             <label>Address(House No,Building,Street,Area)*</label>
//                             <textarea className='form-control' placeholder='Address(House No,Building,Street,Area)' name='address' value={formData.address} onChange={handleInput} required />
//                         </div>
//                         <div className='form-group'>
//                             <label>Locality/Town*:</label>
//                             <Select
//                                 id="my-select"
//                                 onChange={(selectedOption) => handleChange(selectedOption, "landmark")}
//                                 options={options.map(res => ({ value: res.id, label: res.name }))}
//                                 value={options.map(res => ({ "value": res.id, "label": res.name })).find(res => res.label === formData.landmark)}
//                                 placeholder="Locality/Town"
//                                 name='landmark'
//                                 required
//                             />
//                         </div>
//                         <div className='row'>
//                             <div className='col-md-6'>
//                                 <div className='form-group'>
//                                     <input className='form-control' value={City} disabled />
//                                 </div>
//                             </div>
//                             <div className='col-md-6'>
//                                 <div className='form-group'>
//                                     <input className='form-control' value={state} disabled />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
//                         <div className='d-flex my-4'>
//                             <div class={`addressFormUI-base-addressTypeIcon ${formData.adress_type === "Home" ? "addressFormUI-base-selectedAddressType" : ""}`} id="addressType-home" data-value="Home" onClick={() => setFormData({ ...formData, "adress_type": "Home" })}>Home</div>
//                             <div class={`addressFormUI-base-addressTypeIcon ${formData.adress_type === "Work" ? "addressFormUI-base-selectedAddressType" : ""}`} id="addressType-home" data-value="Work" onClick={() => setFormData({ ...formData, "adress_type": "Work" })}>Work</div>
//                         </div>
//                         <Modal.Footer>
//                             <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                         </Modal.Footer>
//                     </form> :
//                         <FormParser modelObject={MastersModal} formSubmit={formSubmit} error={Error} formData={Data} buttonTitle={"Save Address"} />
//                 }
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// Full AddAddress component with Google Maps Autocomplete and Click-to-Fill Map Integration
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);
//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const fetchLocalities = async (pincode) => {
//         if (pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?pincode=${pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name || "");
//                     setState(res.data.results[0]?.city?.state?.state_name || "");
//                     setError(false);
//                 } else {
//                     setOptions([]);
//                     setError(true);
//                     setCity("");
//                     setState("");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         fetchLocalities(formData.pincode);
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (!addressModal) return;

//         const loader = new Loader({
//             apiKey: "AIzaSyB1SvXKyEN6GVemqHKUf4m50SVw1LFrHtA",
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [addressModal]);

//     return (
//         <Modal
//             size="lg"
//             show={addressModal}
//             onHide={handleCloseModal}
//             aria-labelledby="example-modal-sizes-title-lg"
//             centered
//         >
//             <Modal.Header closeButton>
//                 <Modal.Title id="example-modal-sizes-title-lg">
//                     {Data?.id ? "Edit Address" : "Add Address"}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' placeholder='Name' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' placeholder='Mobile No' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>ADDRESS</div>
//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>

//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' placeholder='Pincode' maxLength="6" name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this selected pincode</div>}
//                     </div>

//                     <div className='form-group'>
//                         <label>Address (House No, Building, Street, Area)*</label>
//                         <textarea className='form-control' placeholder='Address' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>

//                     {/* <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             id="my-select"
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark)}
//                             placeholder="Locality/Town"
//                             name='landmark'
//                             required
//                         />
//                     </div> */}

//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={City} placeholder="City" disabled />
//                             </div>
//                         </div>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={state} placeholder="State" disabled />
//                             </div>
//                         </div>
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>

//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>

//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);
//     const [googleKey, setGoogleKey] = useState("");

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: localStorage.getItem("number") || "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);
//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const fetchLocalities = async (pincode) => {
//         if (pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?pincode=${pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name || "");
//                     setState(res.data.results[0]?.city?.state?.state_name || "");
//                     setError(false);
//                 } else {
//                     setOptions([]);
//                     setError(true);
//                     setCity("");
//                     setState("");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     const getGoogleMapKey = async () => {
//         try {
//             const res = await axiosConfig.get(`/masters/googlemapkey/`);

//             if (res.data.length > 0) {
//                 setGoogleKey(res.data.results[0].key);
//             }
//         } catch (err) {
//             console.error("Failed to fetch Google Maps key", err);
//         }
//     };
//     console.log(googleKey, "Kst")
//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         fetchLocalities(formData.pincode);
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (addressModal) {
//             getGoogleMapKey();
//         }
//     }, [addressModal]);

//     useEffect(() => {
//         if (!addressModal || !googleKey) return;

//         const loader = new Loader({
//             apiKey: googleKey,
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [googleKey, addressModal]);

//     return (
//         <Modal size="lg" show={addressModal} onHide={handleCloseModal} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>{Data?.id ? "Edit Address" : "Add Address"}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>
//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this pincode</div>}
//                     </div>
//                     <div className='form-group'>
//                         <label>Address*:</label>
//                         <textarea className='form-control' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark)}
//                             placeholder="Locality/Town"
//                             required
//                         />
//                     </div>
//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <input className='form-control' value={City} disabled placeholder="City" />
//                         </div>
//                         <div className='col-md-6'>
//                             <input className='form-control' value={state} disabled placeholder="State" />
//                         </div>
//                     </div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>
//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>
//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);
//     const [googleKey, setGoogleKey] = useState("");

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: localStorage.getItem("number") || "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);
//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const fetchLocalities = async (pincode) => {
//         if (pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?pincode=${pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name || "");
//                     setState(res.data.results[0]?.city?.state?.state_name || "");
//                     setError(false);
//                 } else {
//                     setOptions([]);
//                     setError(true);
//                     setCity("");
//                     setState("");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     const getGoogleMapKey = async () => {
//         try {
//             const res = await axiosConfig.get(`/masters/googlemapkey/`);
//             console.log("Google Maps Key Response:", res);
//             if (res.data?.results?.length > 0) {
//                 setGoogleKey(res.data.results[0].key);
//             }
//         } catch (err) {
//             console.error("Failed to fetch Google Maps key", err);
//         }
//     };

//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         fetchLocalities(formData.pincode);
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (addressModal) {
//             getGoogleMapKey();
//         }
//     }, [addressModal]);

//     useEffect(() => {
//         if (!addressModal || !googleKey) return;

//         const loader = new Loader({
//             apiKey: googleKey,
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !mapRef.current || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [googleKey, addressModal]);

//     return (
//         <Modal size="lg" show={addressModal} onHide={handleCloseModal} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>{Data?.id ? "Edit Address" : "Add Address"}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>
//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this pincode</div>}
//                     </div>
//                     <div className='form-group'>
//                         <label>Address*:</label>
//                         <textarea className='form-control' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>
//                     {/* <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark)}
//                             placeholder="Locality/Town"
//                             required
//                         />
//                     </div> */}
//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <input className='form-control' value={City} disabled placeholder="City" />
//                         </div>
//                         <div className='col-md-6'>
//                             <input className='form-control' value={state} disabled placeholder="State" />
//                         </div>
//                     </div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>
//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>
//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);
//     const [googleKey, setGoogleKey] = useState("");

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: localStorage.getItem("number") || "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: localStorage.getItem("number") || "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);

//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const fetchLocalities = async (pincode) => {
//         if (pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?pincode=${pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name || "");
//                     setState(res.data.results[0]?.city?.state?.state_name || "");
//                     setError(false);
//                 } else {
//                     setOptions([]);
//                     setError(true);
//                     setCity("");
//                     setState("");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     const getGoogleMapKey = async () => {
//         try {
//             const res = await axiosConfig.get(`/masters/googlemapkey/`);
//             if (res.data?.results?.length > 0) {
//                 setGoogleKey(res.data.results[0].key);
//             }
//         } catch (err) {
//             console.error("Failed to fetch Google Maps key", err);
//         }
//     };

//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         fetchLocalities(formData.pincode);
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (addressModal) {
//             getGoogleMapKey();
//         }
//     }, [addressModal]);

//     useEffect(() => {
//         if (!addressModal || !googleKey) return;

//         const loader = new Loader({
//             apiKey: googleKey,
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !mapRef.current || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [googleKey, addressModal]);

//     return (
//         <Modal size="lg" show={addressModal} onHide={handleCloseModal} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>{Data?.id ? "Edit Address" : "Add Address"}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>ADDRESS</div>
//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>
//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this pincode</div>}
//                     </div>
//                     <div className='form-group'>
//                         <label>Address (House No, Building, Street, Area)*:</label>
//                         <textarea className='form-control' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark) || null}
//                             placeholder="Locality/Town"
//                             required
//                         />
//                     </div>
//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={City} disabled placeholder="City" />
//                             </div>
//                         </div>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={state} disabled placeholder="State" />
//                             </div>
//                         </div>
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>

//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>

//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);
//     const [googleKey, setGoogleKey] = useState("");

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: localStorage.getItem("number") || "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: localStorage.getItem("number") || "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);

//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const fetchLocalities = async (pincode) => {
//         if (pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?pincode=${pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name || "");
//                     setState(res.data.results[0]?.city?.state?.state_name || "");
//                     setError(false);
//                 } else {
//                     setOptions([]);
//                     setError(true);
//                     setCity("");
//                     setState("");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     const getGoogleMapKey = async () => {
//         try {
//             const res = await axiosConfig.get(`/masters/googlemapkey/`);
//             if (res.data?.results?.length > 0) {
//                 setGoogleKey(res.data.results[0].key);
//             }
//         } catch (err) {
//             console.error("Failed to fetch Google Maps key", err);
//         }
//     };

//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         fetchLocalities(formData.pincode);
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (addressModal) {
//             getGoogleMapKey();
//         }
//     }, [addressModal]);

//     useEffect(() => {
//         if (!addressModal || !googleKey) return;

//         const loader = new Loader({
//             apiKey: googleKey,
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !mapRef.current || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [googleKey, addressModal]);

//     return (
//         <Modal size="lg" show={addressModal} onHide={handleCloseModal} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>{Data?.id ? "Edit Address" : "Add Address"}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' placeholder='Name' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' placeholder='Mobile No' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>ADDRESS</div>
//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>

//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' placeholder='Pincode' name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this selected pincode</div>}
//                     </div>

//                     <div className='form-group'>
//                         <label>Address (House No, Building, Street, Area)*</label>
//                         <textarea className='form-control' placeholder='Address(House No, Building, Street, Area)' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>

//                     <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark) || null}
//                             placeholder="Locality/Town"
//                             name='landmark'
//                             required
//                         />
//                     </div>

//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={City} disabled placeholder="City" />
//                             </div>
//                         </div>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={state} disabled placeholder="State" />
//                             </div>
//                         </div>
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>

//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>

//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosConfig from "../../Service/axiosConfig";
// import { Loader } from '@googlemaps/js-api-loader';

// function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
//     const [options, setOptions] = useState([]);
//     const [City, setCity] = useState("");
//     const [state, setState] = useState("");
//     const [error, setError] = useState(false);
//     const [googleKey, setGoogleKey] = useState("");

//     const inputRef = useRef();
//     const mapRef = useRef();
//     const markerRef = useRef();
//     const geocoderRef = useRef();

//     const [formData, setFormData] = useState({
//         name: "",
//         pincode: localStorage.getItem("pincode") || "",
//         mobileno: localStorage.getItem("number") || "",
//         address: "",
//         landmark: "",
//         adress_type: "Home"
//     });

//     const handleInput = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleChange = (selectedOption) => {
//         setFormData({ ...formData, landmark: selectedOption.label });
//     };

//     const handleCloseModal = () => {
//         closeAddressModal();
//         setFormData({
//             name: "",
//             pincode: localStorage.getItem("pincode") || "",
//             mobileno: localStorage.getItem("number") || "",
//             address: "",
//             landmark: "",
//             adress_type: "Home"
//         });
//         setError(false);
//         setCity("");
//         setState("");
//         setData && setData();
//     };

//     const formConventionalSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = { ...formData, user: localStorage.getItem("userId") };
//             const res = formData.id
//                 ? await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload)
//                 : await axiosConfig.post(`/accounts/address/`, payload);

//             setPopupType("success");
//             handleCloseModal();
//             GetData && GetData();
//         } catch (err) {
//             console.error(err);
//             setPopupType("error");
//         }
//     };

//     const localityFilter = async () => {
//         if (formData.pincode.length === 6) {
//             try {
//                 const res = await axiosConfig.get(`/masters/areas/?city=&is_suspended=false&pincode=${formData.pincode}`);
//                 if (res.data.results.length > 0) {
//                     setOptions(res.data.results);
//                     setCity(res.data.results[0]?.city?.city_name);
//                     setState(res.data.results[0]?.city?.state?.state_name);
//                     setError(false);
//                 } else {
//                     setError(true);
//                     setCity("");
//                     setState("");
//                     setOptions([]);
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError(true);
//             }
//         }
//     };

//     const updateMarkerAndForm = (map, lat, lng, fullAddress, pincode, city, stateName) => {
//         setFormData((prev) => ({ ...prev, address: fullAddress, pincode }));
//         setCity(city);
//         setState(stateName);
//         if (!markerRef.current) {
//             markerRef.current = new window.google.maps.Marker({ position: { lat, lng }, map });
//         } else {
//             markerRef.current.setPosition({ lat, lng });
//         }
//         map.setCenter({ lat, lng });
//         map.setZoom(15);
//     };

//     const getGoogleMapKey = async () => {
//         try {
//             const res = await axiosConfig.get(`/masters/googlemapkey/`);
//             if (res.data?.results?.length > 0) {
//                 setGoogleKey(res.data.results[0].key);
//             }
//         } catch (err) {
//             console.error("Failed to fetch Google Maps key", err);
//         }
//     };

//     useEffect(() => {
//         if (Data) {
//             setFormData(Data);
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 pincode: localStorage.getItem("pincode") || "",
//                 mobileno: localStorage.getItem("number") || "",
//             }));
//         }
//     }, [Data, addressModal]);

//     useEffect(() => {
//         localityFilter();
//     }, [formData.pincode]);

//     useEffect(() => {
//         if (addressModal) {
//             getGoogleMapKey();
//         }
//     }, [addressModal]);

//     useEffect(() => {
//         if (!addressModal || !googleKey) return;

//         const loader = new Loader({
//             apiKey: googleKey,
//             version: "weekly",
//             libraries: ["places"]
//         });

//         loader.load().then(() => {
//             if (!window.google || !mapRef.current || !inputRef.current) return;

//             const map = new window.google.maps.Map(mapRef.current, {
//                 center: { lat: 20.5937, lng: 78.9629 },
//                 zoom: 5,
//             });

//             geocoderRef.current = new window.google.maps.Geocoder();

//             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
//                 types: ["geocode"],
//                 componentRestrictions: { country: "in" },
//             });

//             autocomplete.addListener("place_changed", () => {
//                 const place = autocomplete.getPlace();
//                 if (!place.geometry) return;

//                 const lat = place.geometry.location.lat();
//                 const lng = place.geometry.location.lng();
//                 const fullAddress = place.formatted_address;

//                 let pincode = "", city = "", stateName = "";
//                 place.address_components.forEach((comp) => {
//                     if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                     if (comp.types.includes("locality")) city = comp.long_name;
//                     if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                 });

//                 updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//             });

//             map.addListener("click", (e) => {
//                 const lat = e.latLng.lat();
//                 const lng = e.latLng.lng();

//                 geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
//                     if (status === "OK" && results[0]) {
//                         const fullAddress = results[0].formatted_address;
//                         let pincode = "", city = "", stateName = "";
//                         results[0].address_components.forEach((comp) => {
//                             if (comp.types.includes("postal_code")) pincode = comp.long_name;
//                             if (comp.types.includes("locality")) city = comp.long_name;
//                             if (comp.types.includes("administrative_area_level_1")) stateName = comp.long_name;
//                         });

//                         updateMarkerAndForm(map, lat, lng, fullAddress, pincode, city, stateName);
//                     }
//                 });
//             });
//         });
//     }, [googleKey, addressModal]);

//     return (
//         <Modal size="lg" show={addressModal} onHide={handleCloseModal} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>
//                     {Data?.id ? "Edit Address" : "Add Address"}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form onSubmit={formConventionalSubmit}>
//                     <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
//                     <div className='form-group'>
//                         <label>Name*:</label>
//                         <input className='form-control' placeholder='Name' name='name' value={formData.name} onChange={handleInput} required />
//                     </div>
//                     <div className='form-group'>
//                         <label>Mobile No*:</label>
//                         <input className='form-control' placeholder='Mobile No' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>ADDRESS</div>

//                     <div className='form-group'>
//                         <label>Search Address (via Google Maps):</label>
//                         <input ref={inputRef} className='form-control' placeholder='Search your address on map' />
//                     </div>

//                     <div className='form-group'>
//                         <label>Pincode*:</label>
//                         <input className='form-control' type='number' placeholder='Pincode' name='pincode' value={formData.pincode} onChange={handleInput} required />
//                         {error && <div className="Loginerror">Service not available for this selected pincode</div>}
//                     </div>

//                     <div className='form-group'>
//                         <label>Address (House No, Building, Street, Area)*</label>
//                         <textarea className='form-control' placeholder='Address(House No, Building, Street, Area)' name='address' value={formData.address} onChange={handleInput} required />
//                     </div>

//                     <div className='form-group'>
//                         <label>Locality/Town*:</label>
//                         <Select
//                             onChange={handleChange}
//                             options={options.map(res => ({ value: res.id, label: res.name }))}
//                             value={options.map(res => ({ value: res.id, label: res.name })).find(res => res.label === formData.landmark) || null}
//                             placeholder="Locality/Town"
//                             name='landmark'
//                             required
//                         />
//                     </div>

//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={City} disabled placeholder="City" />
//                             </div>
//                         </div>
//                         <div className='col-md-6'>
//                             <div className='form-group'>
//                                 <input className='form-control' value={state} disabled placeholder="State" />
//                             </div>
//                         </div>
//                     </div>

//                     <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
//                     <div className='d-flex my-4'>
//                         {['Home', 'Work'].map((type) => (
//                             <div
//                                 key={type}
//                                 className={`addressFormUI-base-addressTypeIcon ${formData.adress_type === type ? "addressFormUI-base-selectedAddressType" : ""}`}
//                                 onClick={() => setFormData({ ...formData, adress_type: type })}
//                             >
//                                 {type}
//                             </div>
//                         ))}
//                     </div>

//                     <div ref={mapRef} style={{ width: '100%', height: '300px', marginTop: '20px' }}></div>

//                     <Modal.Footer>
//                         <button type="submit" className="btn btn-primary btn-block">Save Address</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AddAddress;
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FormParser } from '../FormParser/FormParser';
import Select from 'react-select';
import axiosConfig from "../../Service/axiosConfig"
import { PiNutFill } from 'react-icons/pi';
function AddAddress({ addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
    const [options, setOptions] = useState([])
    const [selectedOption, setSelectedOption] = useState(null);
    const [ADDRESSType, setAddressType] = useState("Home");
    const [City, setcity] = useState("");
    const [error, setError] = useState(false);
    const [state, setState] = useState("");
    let storedPincode = localStorage.getItem("pincode") ? (localStorage.getItem("pincode")) : "";
    const [formData, setFormData] = useState({
        name: "",
        pincode: storedPincode,
        mobileno: "",
        address: "",
        landmark: "",
        adress_type: "Home"
    });
    // Handle change event
    const handleChange = (selectedOption) => {
        setFormData({ ...formData, ["landmark"]: selectedOption.label })
    };
    const handleInput = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }
    console.log(formData)
    const formConventionalSubmit = async (e) => {
        e.preventDefault();
        try {
            if (formData.id) {
                const res = await axiosConfig.patch(`/accounts/address/${formData.id}/`, { ...formData, "user": localStorage.getItem("userId") });
                console.log(res, "address added")
                setPopupType("success")
                handleCloseModal();
                setcity("")
                setState("")
                GetData && GetData();
            }
            else {
                const res = await axiosConfig.post(`/accounts/address/`, { ...formData, "user": localStorage.getItem("userId") });
                console.log(res, "address added")
                setPopupType("success")
                handleCloseModal();
                setcity("")
                setState("")
                GetData && GetData();
            }
        }
        catch (error) {
            console.error(error);
            setPopupType("error")
        }
    }
    const localityFilter = async () => {
        if (formData.pincode.length === 6) {
            try {
                const res = await axiosConfig.get(`/masters/areas/?city=&is_suspended=false&pincode=${formData.pincode}`);
                if (res.data.results.length > 0) {
                    setOptions(res.data.results)
                    setcity(res.data.results[0]?.city?.city_name)
                    setState(res.data.results[0]?.city?.state?.state_name)
                    setError(false)
                }
                else {
                    setError(true)
                    setcity("")
                    setState("")
                    setOptions([])
                }
            }
            catch (error) {
                console.error(error);
                setError(true)
            }
        }
        else {
            return null
        }
    }
    const handleCloseModal = () => {
        closeAddressModal()
        setError("")
        setState("")
        setcity("")
        setData&&setData()
        const storedPincode = localStorage.getItem("pincode") ? (localStorage.getItem("pincode")) : "";
        setFormData({
            name: "",
            pincode: storedPincode,
            mobileno: "",
            address: "",
            landmark: "",
            adress_type: "Home"
        })
    }
    useEffect(() => {
        if (Data) {
            console.log("Data")
            setFormData(Data);
        } else {
            const storedPincode = localStorage.getItem("pincode") || "";
            const number = localStorage.getItem("number") || "";
            setFormData(prevFormData => ({
                ...prevFormData,
                pincode: storedPincode,
                mobileno:number
            }));
        }
    }, [Data, addressModal]);

    useEffect(() => {
        localityFilter();
    }, [formData.pincode,addressModal]);

    return (
        <Modal
            size="lg"
            show={addressModal}
            onHide={handleCloseModal}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    {Data?.id ? "Edit Address" : "Add Address"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    JSON.parse(localStorage.getItem("site_data"))?.ecommerce_type === "Conventional" ? <form onSubmit={formConventionalSubmit}>
                        <div className='addressFormUI-base-formHeader'>CONTACT DETAILS</div>
                        <div className='form-group'>
                            <label>Name*:</label>
                            <input className='form-control' placeholder='Name' name='name' value={formData.name} onChange={handleInput} required />
                        </div>
                        <div className='form-group'>
                            <label>Mobile No*:</label>
                            <input className='form-control' placeholder='Mobile No' name='mobileno' value={formData.mobileno} onChange={handleInput} required />
                        </div>
                        <div className='addressFormUI-base-formHeader'>ADDRESS</div>
                        <div className='form-group'>
                            <label>Pincode*:</label>
                            <input className='form-control' type='number' placeholder='Pincode' maxLength="6" name='pincode' value={formData.pincode} onChange={handleInput} required />
                            {error &&
                                <div className="Loginerror">Service not available for this selected pincode</div>
                            }
                        </div>
                        <div className='form-group'>
                            <label>Address(House No,Building,Street,Area)*</label>
                            <textarea className='form-control' placeholder='Address(House No,Building,Street,Area)' name='address' value={formData.address} onChange={handleInput} required />
                        </div>
                        <div className='form-group'>
                            <label>Locality/Town*:</label>
                            <Select
                                id="my-select"
                                onChange={(selectedOption) => handleChange(selectedOption, "landmark")}
                                options={options.map(res => ({ value: res.id, label: res.name }))}
                                value={options.map(res => ({ "value": res.id, "label": res.name })).find(res => res.label === formData.landmark)}
                                placeholder="Locality/Town"
                                name='landmark'
                                required
                            />
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <input className='form-control' value={City} disabled />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <input className='form-control' value={state} disabled />
                                </div>
                            </div>
                        </div>
                        <div className='addressFormUI-base-formHeader'>SAVE ADDRESS AS</div>
                        <div className='d-flex my-4'>
                            <div class={`addressFormUI-base-addressTypeIcon ${formData.adress_type === "Home" ? "addressFormUI-base-selectedAddressType" : ""}`} id="addressType-home" data-value="Home" onClick={() => setFormData({ ...formData, "adress_type": "Home" })}>Home</div>
                            <div class={`addressFormUI-base-addressTypeIcon ${formData.adress_type === "Work" ? "addressFormUI-base-selectedAddressType" : ""}`} id="addressType-home" data-value="Work" onClick={() => setFormData({ ...formData, "adress_type": "Work" })}>Work</div>
                        </div>
                        <Modal.Footer>
                            <button type="submit" className="btn btn-primary btn-block">Save Address</button>
                        </Modal.Footer>
                    </form> :
                        (MastersModal?<FormParser modelObject={MastersModal} formSubmit={formSubmit} error={Error} formData={Data} buttonTitle={"Save Address"} />:null)
                }
            </Modal.Body>
        </Modal>
    );
}

export default AddAddress;
